/** The destination prefix the backend reports when a phone number's country code can't be resolved. */
export const SMS_USAGE_UNKNOWN_PREFIX = 'unknown';
